import React, { useEffect } from "react";
import styles from "../styles/corporate.module.css";
import { Search } from "lucide-react";
import Pagination from "../pages/Pagination";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import loc from "../assets/proicons_location.svg";
import date from "../assets/hugeicons_date-time.svg";
import { useLocation } from "react-router-dom";

const Corporate = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <div className={styles.maxWidth}>
          <h2 className={styles.heading}>Corporate Affairs Manager</h2>
          <div className={styles.paragraph}>
            <p style={{ color: "var(--primary-green)" }}>1 open positions</p>
            <p style={{ color: "gray" }}>
              <strong>Job Title:</strong> Corporate Affairs Manager{" "}
            </p>
            <p style={{ color: "gray" }}>
              <strong>Reports To:</strong> Chief Legal Officer
            </p>
          </div>

          <div className={styles.locationContainer}>
            <img src={loc} alt="location" className={styles.locationIcon} />
            <p className={styles.locationText}>
              Namibia Street, Warka Tower 5th Floor Tele Medhanealem Addis Ababa
              AA 1000 Ethiopia
            </p>
          </div>

          <div className={styles.locationContainer}>
            <img src={date} alt="location" className={styles.locationIcon} />
            <p className={styles.locationText}>02/04/2025</p>
          </div>
          <div className={styles.button}>
            <Link to="/corporate1">
              <button
                style={{
                  backgroundColor: "var(--primary-green)",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "10px",
                  marginTop: "20px",
                }}
              >
                Apply Now{" "}
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className={styles.internationalPaymentsSection}>
        <div className={styles.paymentDetails}>
          <h2>Jobs Summary</h2>
          <p style={{ color: "gray" }}>
            The Corporate Affairs Manager will be responsible for overseeing the
            company's legal and regulatory compliance,
            <br />
            corporate governance, and stakeholder relations. This role ensures
            adherence to all applicable laws, regulations,
            <br />
            internal policies, and corporate governance standards. The Corporate
            Affairs Manager will also handle company
            <br />
            secreterial duties, regulatory filings, corporate documentation, and
            provide support in legal advisory matters.
          </p>

          <h2>Key Responsibilities</h2>
          <h4>Regulatory Compliance & Governance:</h4>
          <p style={{ color: "gray" }}>
            Maintain statutory records, company registers, and ensure timely
            filings with regulatory authorities.
            <br />
            Ensure compliance with corporate governance codes, laws, and
            internal policies.
            <br />
            Monitor and ensure adherence to all applicable laws, regulations,
            directives and guidelines issued by relevant
            <br />
            authorities, including the National Bank of Ethiopia.<br></br>{" "}
            Liaise with regulators such as the National Bank of Ethiopia,
            Information Network
            <br />
            Security Authority, Financial Intelligence Service, and tax
            authorities to ensure timely submissions and responses.
            <br />
            Conduct periodic compliance assessments and recommend corrective
            actions.
          </p>

          <h4>Legal Advisory & Contract Management</h4>
          <p style={{ color: "gray" }}>
            Review, draft, and manage contracts, agreements, MOUs, and legal
            documents.
            <br />
            Conduct legal research and provide advice on corporate legal matters
            and business transactions.
            <br />
            Prepare and review legal documents, including statements of claim,
            defense, and appeals for court cases.
            <br />
            Represent the company in legal proceedings before courts and
            quasi-judicial bodies.
          </p>

          <h4>Corporate Affairs & Documentation:</h4>
          <p style={{ color: "gray" }}>
            Coordinate communication with shareholders, regulatory bodies,
            external auditors, and other key stakeholders.
            <br />
            Draft official correspondence, notifications, and reports for
            regulatory submissions and stakeholder engagement.
            <br />
            Maintain organized and up-to-date corporate records, including
            shareholding documents, licenses, approvals, and
            <br />
            permits.
            <br />
            Implement and manage a secure document management system for
            efficient storage and retrieval of corporate
            <br />
            records.
          </p>

          <Link to="/corporate1">
            <button
              className={styles.primaryButton}
              style={{
                backgroundColor: "var(--primary-green)",
                padding: "10px 20px",
                border: "none",
                borderRadius: "10px",
              }}
            >
              Apply Now →
            </button>
          </Link>
        </div>
      </div>

      <Pagination />

      <Footer />
    </div>
  );
};

export default Corporate;
